import { render, staticRenderFns } from "./ProjectsIndex.vue?vue&type=template&id=a09bec76&scoped=true&"
import script from "./ProjectsIndex.vue?vue&type=script&lang=js&"
export * from "./ProjectsIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsIndex.vue?vue&type=style&index=0&id=a09bec76&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09bec76",
  null
  
)

export default component.exports